'use client'

import {
  ButtonOutLineBreakpoint,
  SpinButton,
  SpinButtonOutlintBreakpoint,
  SpinButtonWithoutBreakpoint,
} from './button.style'
import { SpinAnimation } from '@/components/v2/atoms/spin-animation/spin-animation'

const ButtonWithSpin = ({ label, loading, onClick, gap, icon = null }: any) => {
  return (
    <SpinButton onClick={onClick} disabled={loading} gap={gap}>
      {loading && <SpinAnimation />}
      {icon}
      {label}
    </SpinButton>
  )
}

export const Button = ({
  label,
  loading,
  onClick,
  gap,
  icon = null,
  containerStyle = null,
  disableButton,
  labelTransform,
  className,
}: any) => {
  return (
    <SpinButtonWithoutBreakpoint
      className={className}
      onClick={onClick}
      disabled={loading || disableButton}
      gap={gap}
      style={containerStyle}
      labelTransform={labelTransform}
    >
      {loading && <SpinAnimation />}
      {icon}
      {label}
    </SpinButtonWithoutBreakpoint>
  )
}

export const ButtonOutLineWithBorder = ({
  label,
  loading,
  onClick,
  gap,
  icon = null,
  containerStyle = null,
  disableButton,
  bold = false,
  color,
  active,
  activebg,
}: any) => {
  return (
    <SpinButtonOutlintBreakpoint
      active={active}
      activebg={activebg}
      onClick={onClick}
      disabled={loading || disableButton}
      gap={gap}
      style={containerStyle}
      bold={bold}
      color={color}
    >
      {loading ? (
        <SpinAnimation />
      ) : (
        <>
          {icon}
          {label}
        </>
      )}
    </SpinButtonOutlintBreakpoint>
  )
}

export const ButtonOutLine = ({
  label,
  loading,
  onClick,
  gap,
  icon = null,
  containerStyle = null,
  disableButton,
}: any) => {
  return (
    <ButtonOutLineBreakpoint
      onClick={onClick}
      disabled={loading || disableButton}
      gap={gap}
      style={containerStyle}
    >
      {loading && <SpinAnimation />}
      {icon}
      {label}
    </ButtonOutLineBreakpoint>
  )
}

export const ButtonFile = ({
  label,
  loading,
  gap,
  icon = null,
  onChange,
  disableButton,
}: any) => {
  return (
    <label htmlFor="file">
      <ButtonOutLineWithBorder
        label={label}
        loading={loading}
        gap={gap}
        icon={icon}
        disableButton={disableButton}
        containerStyle={{ margin: '1rem 0' }}
        bold
      />
      <input
        type="file"
        id="file"
        style={{ display: 'none' }}
        onChange={onChange}
        accept="image/*"
      />
    </label>
  )
}

